import {
  Alert,
  Button,
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateHeader
} from "@relex-solutions/fragments"
import { useTranslation } from "react-i18next"
import { useAuth } from "@/shared/hooks/useAuth"
import { useAuthorization } from "@/shared/hooks/useAuthorization"
import { useRequestAccess } from "@/shared/hooks/useRequestAccess"
import styles from "./UnauthorizedPage.module.css"

export function UnauthorizedPage() {
  const { retry } = useAuthorization()
  const { t } = useTranslation()
  const { user } = useAuth()
  const { handleRequestAccess, showAlert, alertIsSuccess, isPending, isSuccess } = useRequestAccess()

  return (
    <EmptyState className={styles.container}>
      <EmptyStateHeader>{t("unauthorized.pageTitle")}</EmptyStateHeader>
      <EmptyStateDescription>{t("unauthorized.description", { subId: user?.sub })}</EmptyStateDescription>

      {showAlert && (
        <div className={styles.alertContainer}>
          <Alert
            color={alertIsSuccess ? "success" : "error"}
            header={alertIsSuccess ? t("unauthorized.requestSuccessTitle") : t("unauthorized.requestErrorTitle")}
          >
            {alertIsSuccess ? t("unauthorized.requestSuccessDescription") : t("unauthorized.requestErrorDescription")}
          </Alert>
        </div>
      )}

      <EmptyStateActions>
        <Button variant="primary" onClick={() => void retry()}>
          {t("unauthorized.button")}
        </Button>
        <Button
          variant="secondary"
          onClick={handleRequestAccess}
          disabled={isPending || isSuccess}
          isLoading={isPending}
        >
          {isSuccess ? t("unauthorized.requestedButtonLabel") : t("unauthorized.requestButtonLabel")}
        </Button>
      </EmptyStateActions>
    </EmptyState>
  )
}
